import React from "react";
import { PROGRESS_MODE } from "../progressMode";

export default function ProgressBar({
  mode = PROGRESS_MODE.INDETERMINATE,
  percent = null,
  label = "",
  className = "",
  size = "md",
}) {
  const isDeterminate = mode === PROGRESS_MODE.DETERMINATE && percent != null;

  return (
    <div className={`gl-progress-wrap ${className}`}>
      <div
        className={`gl-progress-track gl-progress-track--${size}`}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={isDeterminate ? percent : undefined}
        aria-busy={!isDeterminate || percent < 100}
      >
        <div
          className={`gl-progress-fill ${isDeterminate ? "gl-progress-fill--determinate" : "gl-progress-fill--indeterminate"}`}
          style={isDeterminate ? { width: `${percent}%` } : undefined}
        />
      </div>
      {isDeterminate && (
        <div className="gl-progress-meta">
          <span className="gl-progress-pct">{percent}%</span>
          {label ? <span className="gl-progress-count">{label}</span> : null}
        </div>
      )}
    </div>
  );
}
